/*
* edit carefitHeader template from carefitHeader template
* remove doctorDetails template (not required)
* edit presciptionCardHeader template
* chief complaints template
* public notes template
* lab test template
* */

export const carefitHeader = `<div class="prescription-header">
    <img src="https://d1yfs1c2pfwbpr.cloudfront.net/image/carefit/orion/prescription-icons/line.png" alt="line" class="header-line"/>
    <div class="doctor-name">$doctorName</div>
    <div class="doctor-details">
        <div class="qualification-details">$doctorQualifications</div>
        <div class="kmc-details">$doctorKmc</div>
    </div>
    <div class="prescription-logo">
        <span>Powered by </span>
        <img class="logo-big" src="https://d1yfs1c2pfwbpr.cloudfront.net/image/carefit/orion/care-fit.png" alt="logo"/>
        <span class="logo-text">care.fit</span>
    </div>
</div>
`

export const prescriptionCardHeader = `<div class="prescription-card-header">
    <div>
        <div class="patient-name">
            $patientName
            <span class="patient-details">$patientDetails</span>
        </div>
        <div class="sub-details">UHID: $uhid</div>
    </div>
    <div class="flex-right">
        <div class="date prescription-date">$date</div>
        <div class="reasonForVisit">$reasonForVisit</div>
    </div>
</div>`

export const chiefComplaintsTemplate = `<div id="chiefComplaints" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Chief Complaints</div>
        <ul id="chiefComplaints-subsection" class="prescription-description">
            $injectChiefSymptomsBody
        </ul>
    </div>
</div>`

export const chiefComplaintsItem = `<li>
    <span class="prescription-subheading">$injectSymptomDisplayValue</span>
    <span class="prescription-description">$injectSymptomDescription</span>
    <div class="item-subdesc">$injectSymptomComment</div>
</li>
`

export const publicNotesTemplate = `<div id="publicNotes" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Public Notes</div>
        <ul id="publicNotes-subsection" class="prescription-description">
            <li>$injectPublicNotesBody</li>
        </ul>
    </div>
</div>`

export const prescriptionDiagnosisTemplate = `<div id="prescriptionDiagnosis" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Diagnosis</div>
        <ul id="prescriptionDiagnosis-subsection">
            $injectDiagnosisBody
        </ul>
    </div>
</div>`

export const prescriptionDiagnosisItem = `<li>
    <span class="prescription-subheading">$injectDiagnosis</span>
    <span class="prescription-description blue-text">$injectDiagnosisType</span>
    <div class="prescription-subdesc blue-text italic">$injectDiagnosisComment</div>
</li>`

export const prescriptionLabTestsTemplate = `<div id="prescriptionLabTest" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="flex">
            <div class="prescription-sec-heading">Lab tests</div>
            <div class="extra-heading">After</div>
            <div class="extra-heading">Instructions</div>
        </div>
        <ul id="prescriptionLabTest-subsection" class="prescription-description">
            $injectLabTestBodyCont
        </ul>
    </div>
</div>`

export const prescriptionLabTestItem = `<li class="divider">
    <div class="flex">
        <span class="prescription-subheading">$injectLabTest</span>
        <span class="item-details">$injectDuration</span>
        <span class="item-details">$injectInstructions</span>
    </div>
    <div class="prescription-subdesc blue-text italic">$injectDiagnosisComment</div>
</li>`

export const prescriptionMedicinesTemplate = `<div id="prescriptionMedicines" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="flex">
            <div class="prescription-sec-heading">Medicines</div>
            <div class="extra-heading">Qty</div>
            <div class="extra-heading">Timing</div>
            <div class="extra-heading">Intake</div>
            <div class="extra-heading">Frequency</div>
            <div class="extra-heading">Duration</div>
        </div>
        <ul id="prescriptionMedicines-subsection" class="prescription-description">
            $injectMedicineBody
        </ul>
    </div>
</div>`

export const prescriptionMedicineItem = `<li class="divider">
    <div class="flex">
        <span class="prescription-subheading">$injectMedicine</span>
        <span class="item-details">$injectQuantity</span>
        <span class="item-details">$injectTiming</span>
        <span class="item-details">$injectIntake</span>
        <span class="item-details">$injectFrequency</span>
        <span class="item-details">$injectDuration</span>
    </div>
    <div class="prescription-subdesc blue-text italic">$injectComment</div>
</li>`

export const adviceTemplate = `<div id="prescriptionAdvice" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Advice</div>
        <ul id="prescriptionAdvice-subsection">
            $injectAdviceBody
        </ul>
    </div>
</div>`

export const followupTemplate = `<div id="followup" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Followup</div>
        <ul id="followup-subsection" class="recommendation-element">
            $injectFollowupBody
        </ul>
    </div>
</div>`

export const followupItem = `<li class="prescription-description">
    <span class="prescription-subheading">$injectDate</span>
    <div class="prescription-subdesc blue-text italic">$injectFollowupComment</div>
</li>`

export const referralTemplate = `<div id="referral" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Referral</div>
        <ul id="referral-subsection" class="recommendation-element">
            $injectReferralBody
        </ul>
    </div>
</div>`

export const referralItem = `<li class="prescription-description">
    <span class="prescription-subheading">$injectSpeciality</span>
    <div class="prescription-subdesc blue-text italic">$injectReferralComment</div>
</li>`

export const footerNewTemplate = `<div class="prescription-footer">
    <div class="prescription-footer-address">
        <div class="prescription-description">
            $centerAddress
        </div>
    </div>
    <div class="prescription-footer-addon">
        <span>$pageDetail</span>
    </div>
</div>`

export const signatureContTemplate = `<div class="signature-container">
    <div class="add-info">
        <span>$injectAdditionaInfoText</span>
    </div>
    <div class="signature">
        <img src="$signatureUrl" alt="signature" class="signature-img"/>
        <div class="signature-legend">Signature</div>
    </div>
</div>`

export const generalExaminationContTemplate = `<div id="generalExaminations" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">General Examinations</div>
        <ul id="generalExaminations-subsection">
            <li class="prescription-subheading">$injectGeneralExamBody</li>
            <div class="prescription-subdesc blue-text italic">$injectComment</div>
        </ul>
    </div>
</div>`

export const systemicExaminationsContTemplate = `<div id="systemicExaminations"  class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">System Examinations</div>
        <ul id="systemicExaminations-subsection">
            $injectSystemicExaminationBody
        </ul>
    </div>
</div>`

export const systemicExamItemTemplate = `<li>
    <span class="prescription-subheading">$injectSystemicExamCode&nbsp;-&nbsp;</span>
    <span class="prescription-description">$injectSystemicExamComment</span>
</li>`

export const entExaminationsContTemplate = `<div id="entExamination"  class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">ENT Examinations</div>
        <ul id="entExamination-subsection">
            $injectEntExaminationBody
        </ul>
    </div>
</div>`

export const entExamItemTemplate = `<li>
    <span class="prescription-subheading">$injectEntExamCode&nbsp;-&nbsp;</span>
    <span class="prescription-description">$injectEntExamComment</span>
</li>`

export const allergiesContTemplate = `<div id="allergies" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Allergies</div>
        <ul id="vitals-subsection" class="prescription-description">
            $injectAllergies
        </ul>
    </div>
</div>`

export const bodyPartsContTemplate = `<div id="prescriptionBodyPartsCateredTo" class="prescription-grid-row external-row">
    <div class="prescription-card-content">
        <div class="prescription-sec-heading">Body Parts Catered To</div>
        <ul id="prescriptionBodyPartsCateredTo-subsection" class="recommendation-element">
            $injectBodyPartsBody
        </ul>
    </div>
</div>`

export const bodyPartsItemTemplate = `<li>
    <span class="prescription-subheading">$injectBodyPartDisplayValue</span>
    <div class="prescription-subdesc blue-text italic">$injectBodyPartComment</div>
</li>
`